import {
  AbstractControl,
  FormControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { ExpenseType } from '../models/expenseType.enum';

export class Util {
  public static prepareQueryForParameterisedListing(obj: any) {
    if (obj) {
      const parts: any = [];
      for (const property in obj) {
        if (obj[property] !== null) {
          const value = obj[property];
          const qStr = encodeURIComponent(property) + '=' + value;
          parts.push(qStr);
        }
      }
      return parts.join('&');
    }
  }

  public static convertToSeconds(date: any) {
    if (date) {
      const epochMilliSeconds = new Date(date).getTime();
      if (!isNaN(epochMilliSeconds)) {
        const epochSeconds = epochMilliSeconds / 1000;
        return epochSeconds;
      } else {
        return undefined;
      }
    } else {
      return undefined;
    }
  }

  public static titleCase(value: string) {
    const keyword = value;
    const newstr =
      keyword.charAt(0).toUpperCase() + keyword.slice(1).toLowerCase();
    return newstr;
  }

  public static dateFormatFilter(dateoriginal: any) {
    let dateFilter;
    if(dateoriginal){
      const date = new Date(dateoriginal);
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      dateFilter = `${year}-${month}-${day}`;
    } else {
      dateFilter = '';
    }
    return dateFilter;
  }

  public static dateString(dateoriginal: any) {
    const date = new Date(dateoriginal);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const dateform = `${day}.${month}.${year}`;

    return dateform;
  }

  public dateHtml(dateoriginal: Date) {
    const date = new Date(dateoriginal);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const dateform = `${day}.${month}.${year}`;

    return dateform;
  }

  public static dateRange(dateFrom: Date, dateTo: Date) {
    const date1 = new Date(dateFrom);
    const date2 = new Date(dateTo);
    const year1 = date1.getFullYear();
    const month1 = ('0' + (date1.getMonth() + 1)).slice(-2);
    const day1 = ('0' + date1.getDate()).slice(-2);

    const year2 = date2.getFullYear();
    const month2 = ('0' + (date2.getMonth() + 1)).slice(-2);
    const day2 = ('0' + date2.getDate()).slice(-2);

    const daterange = `${day1}.${month1}.${year1} - ${day2}.${month2}.${year2}`;

    return daterange;
  }

  public static findDateWithString(str: string): string[] | boolean {
    const regex = /\b\d{1,2}\.\d{1,2}\.\d{4}\b - \d{1,2}\.\d{1,2}\.\d{4}\b/g;
    const matches = str.match(regex);

    return !!matches;
  }

  public static findDate(str: string): string[] | boolean {
    const regex = /[a-zA-Z] \d{2}\.\d{2}\.\d{4}/;
    const matches = RegExp(regex).exec(str);

    return !!matches;
  }

  public static findOnlyString(str: string): string[] | boolean {
    const regex = /^[a-zA-Z]+$/g;
    const matches = str.match(regex);

    return !!matches;
  }

  public static extractTime(time: any) {
    const timeString = time;
    const [hoursString, minutesString] = timeString
      ? timeString.split(':')
      : [];
    const Hour = parseInt(hoursString, 10);
    const Minute = parseInt(minutesString, 10);

    return { Hour, Minute };
  }

  public static europeanCurrencyFormatValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (
        value?.includes(',') ||
        value?.includes('.') ||
        isNaN(value.replace(',', '.'))
      ) {
        if (!/^\d+,\d{1,2}$/.test(value)) {
          return {
            invalidEuroFormat: true,
            outOfRange: null,
            exceedsTotalCost: null,
          };
        }
      }

      return null;
    };
  }

  public static exceedCostValidator(controlName: FormControl): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      const controlToCheck = controlName;
      const controlToCheckValue = controlToCheck?.value;

      if (/^\d+(,\d{1,2})?$/.test(value)) {
        if (
          parseFloat(value.replace(',', '.')) >
          parseFloat(controlToCheckValue?.replace(',', '.'))
        ) {
          return { exceedsTotalCost: true };
        }
      }
      return null;
    };
  }

  public static euroCurrencyRangeValidator(
    minValue: number,
    maxValue: number
  ): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (!isNaN(value?.replace(',', '.'))) {
        if (!/^\d+(,\d{1,2})?$/.test(value) && value.includes(',')) {
          return {
            invalidEuroFormat: true,
            outOfRange: null,
            exceedsTotalCost: null,
          };
        }

        const numericValue = parseFloat(value.replace(',', '.'));
        if (numericValue < minValue || numericValue > maxValue) {
          return { outOfRange: true, invalidEuroFormat: null };
        }
      }

      return null;
    };
  }

  public static hasControlValue(controlName: FormControl): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      const controlCheckValue = controlName.value;
      if ( controlCheckValue && !value ) {
        return { reuqireValue: true };
      }
      return null;
    };
  }

  public static subscribeResultToValues(
    control1: FormControl,
    control2: FormControl,
    resultControl: FormControl,
    taxControl?: FormControl
  ): void {
    if (control1 && control2) {
      control1.valueChanges.subscribe(() => {
        this.multiplyValues(control1, control2, resultControl);
      });

      control2.valueChanges.subscribe(() => {
        this.multiplyValues(control1, control2, resultControl);
      });
    }

    if (taxControl) {
      resultControl.valueChanges.subscribe(() => {
        taxControl?.updateValueAndValidity();
      });
    }
  }

  public static subscribeResultFromMultipleValues(
    controls: FormControl[],
    resultControl: FormControl
  ): void {
    this.addValues([...controls], resultControl);
    controls.forEach((control) => {
      control.valueChanges.subscribe(() => {
        this.addValues([...controls], resultControl);
      });
    });
  }

  public static multiplyValues(
    inputControl1: FormControl,
    inputControl2: FormControl,
    resultControl: FormControl
  ): void {
    const firstInputControlValue = inputControl1?.value;
    const secondInputControlValue = inputControl2?.value;
    const secondInputControl = inputControl2;

    if (
      firstInputControlValue &&
      secondInputControlValue &&
      /^\d+$/.test(firstInputControlValue) &&
      !secondInputControlValue.includes('.') &&
      !secondInputControl?.invalid
    ) {
      const multiplicationResult = (
        parseInt(firstInputControlValue, 10) *
        parseFloat(secondInputControlValue.replace(',', '.'))
      ).toFixed(2);

      const resultWithComma = multiplicationResult.replace('.', ',');
      resultControl.setValue(resultWithComma?.toString());
    } else {
      resultControl.setValue('0,00');
    }
  }

  public static addValues(
    controls: FormControl[],
    resultControl: FormControl
  ): void {
    const values = controls.map((control) =>
      Number(control?.value?.replace(',', '.') || 0)
    );

    if (values.some((value) => !isNaN(value))) {
      const additionResult = values
        .reduce((sum, value) => sum + value, 0)
        .toFixed(2);

      if (isNaN(parseFloat(additionResult))) {
        resultControl.setValue('0,00');
      } else {
        const resultWithComma = additionResult.replace('.', ',');
        resultControl.setValue(resultWithComma.toString());
      }
    } else {
      resultControl.setValue('0,00');
    }
  }

  public convertToEuroFormat(decimalValue: any): string {
    // Convert the decimal value to a string with fixed two decimal places
    let formattedValue: string = decimalValue?.toFixed(2);

    // Replace the decimal point with a comma
    formattedValue = formattedValue.replace('.', ',');

    return formattedValue;
  }

  public static convertToDecimal(data: any): string | number {
    const numberAndCommaPattern: RegExp = /^[\d,]+$/;
    const allAlphabetsAndCommaPattern: RegExp = /^[a-zA-Z,]+$/;

    if (typeof data === 'string' && numberAndCommaPattern.test(data)) {
      // If the string has numbers and commas, convert to float and return
      return parseFloat(data.replace(',', '.'));
    } else if (allAlphabetsAndCommaPattern.test(data)) {
      // If the string has only alphabets and commas, return the original string
      return data;
    } else if (typeof data === 'string' && data.startsWith('-')) {
      data = data.replace('-', ' ');
      return parseFloat(data.replace(',', '.'));
    } else {
      // For any other cases, return the original string
      return data;
    }
  }

  public static euroFormat(decimalValue: any): string {
    // Convert the decimal value to a string with fixed two decimal places
    let formattedValue: string = decimalValue?.toFixed(2);

    // Replace the decimal point with a comma
    formattedValue = formattedValue?.replace('.', ',');

    return formattedValue;
  }

  public static setEpochDateTime(data: any) {
    const date = new Date(data * 1000);
    const hour = date.getHours();
    const minute = date.getMinutes();
    const time = hour + ':' + minute;
    date.setHours(0);
    date.setMinutes(0);
    return { date, time };
  }

  public static apiDataEuroFormat(key: any, data: any): any {
    const keysForOnlyZero = [
      'price',
      'inputTax',
      'breakfastInputTaxEmployee',
      'additionalBreakfastCostEmployee',
      'additionalBreakfastInputTaxEmployee',
      'noBreakfastInputTaxEmployer',
      'breakfastInputTaxEmployer',
      'noBreakfastInputTaxEmployee',
      'trainInputTaxAmountEmployee',
      'taxiInputTaxAmountEmployee',
      'trainInputTaxAmountEmployer',
      'additionalBreakfastCostEmployer',
      'trainTicketPriceEmployee',
      'trainTicketPriceEmployer',
      'taxiFareEmployee',
      'airplanePriceEmployee',
      'airplaneInputTaxAmountEmployee',
      'otherTransportPriceEmployee',
      'otherTransportPriceEmployee',
      'otherTransportInputTaxAmountEmployee',
      'additionalBreakfastInputTaxEmployer',
      'taxiFareEmployer',
      'airplanePriceEmployer',
      'airplaneInputTaxAmountEmployer',
      'otherTransportPriceEmployer',
      'otherTransportInputTaxAmountEmployer',
      'accommodationPerDayNoBreakfastEmployer',
      'taxiInputTaxAmountEmployer'
    ];

    const keysToExclude = [
      'breakfastDaysEmployee',
      'noBreakfastDaysEmployee',
      'breakfastDaysEmployer',
      'noBreakfastDaysEmployer',
      'lumpDays',
      'ownVehicleKmFourWheelerEmployee',
      'ownVehicleKmTwoWheelerEmployee',
      'ownVehicleKmFourWheelerEmployer',
      'ownVehicleKmTwoWheelerEmployer',
      'kmAllowanceFourWheelerEmployee',
      'kmAllowanceTwoWheelerEmployee',
      'kmAllowanceFourWheelerEmployer',
      'kmAllowanceTwoWheelerEmployer'
    ];

    const keysOfLengthFour = [
      'additionalBreakfastCostEmployee',
      'breakfastInputTaxEmployee',
      'additionalBreakfastInputTaxEmployee',
      'noBreakfastInputTaxEmployee',
      'breakfastInputTaxEmployer',
      'noBreakfastInputTaxEmployee',
      'breakfastInputTaxEmployer',
      'additionalBreakfastCostEmployer',
      'additionalBreakfastInputTaxEmployer',
      'noBreakfastInputTaxEmployer',
      'trainTicketPriceEmployee',
      'trainInputTaxAmountEmployee',
      'trainTicketPriceEmployer',
      'taxiInputTaxAmountEmployee',
      'taxiInputTaxAmountEmployer',
      'taxiFareEmployee',
      'taxiFareEmployer',
      'airplanePriceEmployee',
      'airplanePriceEmployer',
      'airplaneInputTaxAmountEmployee',
      'airplaneInputTaxAmountEmployer',
      'otherTransportPriceEmployee',
      'otherTransportPriceEmployer',
      'otherTransportInputTaxAmountEmployee',
      'otherTransportInputTaxAmountEmployer',
      'trainInputTaxAmountEmployer',
      'price',
      'inputTax',
    ]

    const numberAndCommaPattern: RegExp = /^[\d.]+$/;
    if (typeof data === 'number') {
      data = data.toString();
      const dotIndex = data.lastIndexOf('.');

      if(key === 'accommodationPerDayNoBreakfastEmployee' && data.length === 4 && dotIndex === 2){
        return data.replace('.', ',') + '0';
      }
      if(keysOfLengthFour.includes(key) && data.length === 4 && dotIndex === 1){
        return data.replace('.', ',');
      }

      if(data.length === 1 && !keysToExclude.includes(key)){
        return data + ',00';
      }

      if ( dotIndex === data.length - 1 || (dotIndex === data.length - 2 && keysForOnlyZero.includes(key)) ) {
        return data.replace('.', ',') + '0';
      }

      if ( key === 'breakfastReductionDaysDuringStay' || key === 'lunchReductionDaysDuringStay' || key === 'dinnerReductionDaysDuringStay' ) {
        return data;
      }
      const validLengths = [1, 2, 3, 4];
      if ( validLengths.includes(data.length) && !keysToExclude.includes(key) ) {
        return data + ',00';
      } else if ( data.lastIndexOf('.') === data.length - 2 && data.length !== 1 && data.length !== 2 ) {
        return data.replace('.', ',') + '0';
      } else if ( data.length === 1 && (key === 'price' || key === 'inputTax') ) {
        return data + ',00';
      }

      if (( key === 'kmAllowanceFourWheelerEmployee' || key === 'kmAllowanceTwoWheelerEmployee' || key === 'kmAllowanceFourWheelerEmployer' || key === 'kmAllowanceTwoWheelerEmployer') || (data.lastIndexOf('.') === data.length - 2 && (key === 'price' || key === 'inputTax')) ) {
        return data.replace('.', ',') + '0';
      }

      if (numberAndCommaPattern.test(data)) {
        return data.replace('.', ',');
      } else {
        return data;
      }
    } else {
      return data;
    }
  }

  public static addFormFields(formGroup: any, controlsNameArray: any){

    let total = 0;
    controlsNameArray.forEach((controlName: any) => {
      const value: any = Util.convertToDecimal(formGroup.get(controlName)?.value);
      total += value;
    });
    return total;
  }

  //Check the type of expense form
  public static checkTefType(tefType: string | undefined | null): boolean {
    if (tefType === ExpenseType.SingleDay) {
      return true;
    } else {
      return false;
    }
  }
}
